import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, Observable, takeUntil } from 'rxjs';
import { ScreenType } from 'src/app/enums/ScreenType';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { ICalendarState } from 'src/app/state-management/states/aumye-calendar.state';
import { IAumyeState } from 'src/app/state-management/states/aumye.state';

@Component({
  selector: 'app-calendar-container',
  templateUrl: './calendar-container.component.html',
  styleUrls: ['./calendar-container.component.scss'],
})
export class CalendarContainerComponent {
  destroyed$: Subject<any> = new Subject<any>();
  calendarState$: Observable<ICalendarState>;
  dataSource: any;
  filteredDataSource: any;
  styleTable: { height: string };
  timeSLOTS: any[];
  screenSize: ScreenType;
  ScreenType = ScreenType;

  constructor(
    private store: Store<IAumyeState>,
    private _screenSize: AumyeResponsiveScreenService
  ) {
    this._screenSize.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
    this.calendarState$ = this.store.select('aumyeCalendarState');
    this.calendarState$.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.timeSLOTS = data.timeSlots.list;
      this.dataSource = this.timeSLOTS;
    });
  }
}
